import { useEffect, useState } from 'react';

/**
 * `value`, but only after it has stopped changing for `delayMs`. Used to turn
 * keystrokes into one request per pause rather than one per character.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
